/* tslint:disable */
/* eslint-disable */
/**
 * KNMI exons API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { MaritimeWarningSettings } from '../types';
// @ts-ignore
import type { UpdateMaritimeWarningSettingsBody } from '../types';
// @ts-ignore
import type { ValidationError } from '../types';
/**
 * MaritimeWarningSettingsApi - axios parameter creator
 * @export
 */
export const MaritimeWarningSettingsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Returns MaritimeWarningSettings for a Dashboard.
         * @summary Get MaritimeWarningSettings for Dashboard by ID
         * @param {string} dashboardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMaritimeWarningSettingsForDashboard: async (dashboardId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dashboardId' is not null or undefined
            assertParamExists('getMaritimeWarningSettingsForDashboard', 'dashboardId', dashboardId)
            const localVarPath = `/dashboards/{dashboard_id}/maritime_warning_settings`
                .replace(`{${"dashboard_id"}}`, encodeURIComponent(String(dashboardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates MaritimeWarningSettings.
         * @summary Update MaritimeWarningSettings for Dashboard by ID
         * @param {string} dashboardId 
         * @param {UpdateMaritimeWarningSettingsBody} [updateMaritimeWarningSettingsBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMaritimeWarningSettings: async (dashboardId: string, updateMaritimeWarningSettingsBody?: UpdateMaritimeWarningSettingsBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dashboardId' is not null or undefined
            assertParamExists('updateMaritimeWarningSettings', 'dashboardId', dashboardId)
            const localVarPath = `/dashboards/{dashboard_id}/maritime_warning_settings`
                .replace(`{${"dashboard_id"}}`, encodeURIComponent(String(dashboardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateMaritimeWarningSettingsBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MaritimeWarningSettingsApi - functional programming interface
 * @export
 */
export const MaritimeWarningSettingsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MaritimeWarningSettingsApiAxiosParamCreator(configuration)
    return {
        /**
         * Returns MaritimeWarningSettings for a Dashboard.
         * @summary Get MaritimeWarningSettings for Dashboard by ID
         * @param {string} dashboardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMaritimeWarningSettingsForDashboard(dashboardId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MaritimeWarningSettings>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMaritimeWarningSettingsForDashboard(dashboardId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MaritimeWarningSettingsApi.getMaritimeWarningSettingsForDashboard']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Updates MaritimeWarningSettings.
         * @summary Update MaritimeWarningSettings for Dashboard by ID
         * @param {string} dashboardId 
         * @param {UpdateMaritimeWarningSettingsBody} [updateMaritimeWarningSettingsBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateMaritimeWarningSettings(dashboardId: string, updateMaritimeWarningSettingsBody?: UpdateMaritimeWarningSettingsBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MaritimeWarningSettings>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateMaritimeWarningSettings(dashboardId, updateMaritimeWarningSettingsBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MaritimeWarningSettingsApi.updateMaritimeWarningSettings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * MaritimeWarningSettingsApi - factory interface
 * @export
 */
export const MaritimeWarningSettingsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MaritimeWarningSettingsApiFp(configuration)
    return {
        /**
         * Returns MaritimeWarningSettings for a Dashboard.
         * @summary Get MaritimeWarningSettings for Dashboard by ID
         * @param {string} dashboardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMaritimeWarningSettingsForDashboard(dashboardId: string, options?: RawAxiosRequestConfig): AxiosPromise<MaritimeWarningSettings> {
            return localVarFp.getMaritimeWarningSettingsForDashboard(dashboardId, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates MaritimeWarningSettings.
         * @summary Update MaritimeWarningSettings for Dashboard by ID
         * @param {string} dashboardId 
         * @param {UpdateMaritimeWarningSettingsBody} [updateMaritimeWarningSettingsBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMaritimeWarningSettings(dashboardId: string, updateMaritimeWarningSettingsBody?: UpdateMaritimeWarningSettingsBody, options?: RawAxiosRequestConfig): AxiosPromise<MaritimeWarningSettings> {
            return localVarFp.updateMaritimeWarningSettings(dashboardId, updateMaritimeWarningSettingsBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MaritimeWarningSettingsApi - object-oriented interface
 * @export
 * @class MaritimeWarningSettingsApi
 * @extends {BaseAPI}
 */
export class MaritimeWarningSettingsApi extends BaseAPI {
    /**
     * Returns MaritimeWarningSettings for a Dashboard.
     * @summary Get MaritimeWarningSettings for Dashboard by ID
     * @param {string} dashboardId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MaritimeWarningSettingsApi
     */
    public getMaritimeWarningSettingsForDashboard(dashboardId: string, options?: RawAxiosRequestConfig) {
        return MaritimeWarningSettingsApiFp(this.configuration).getMaritimeWarningSettingsForDashboard(dashboardId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates MaritimeWarningSettings.
     * @summary Update MaritimeWarningSettings for Dashboard by ID
     * @param {string} dashboardId 
     * @param {UpdateMaritimeWarningSettingsBody} [updateMaritimeWarningSettingsBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MaritimeWarningSettingsApi
     */
    public updateMaritimeWarningSettings(dashboardId: string, updateMaritimeWarningSettingsBody?: UpdateMaritimeWarningSettingsBody, options?: RawAxiosRequestConfig) {
        return MaritimeWarningSettingsApiFp(this.configuration).updateMaritimeWarningSettings(dashboardId, updateMaritimeWarningSettingsBody, options).then((request) => request(this.axios, this.basePath));
    }
}

